module.exports = __webpack_public_path__ + "static/media/profile-style-img.38b4bfab.png";